import React from "react";
import "./Education.scss";
import EducationCard from "../../components/educationCard/EducationCard";
import {educationInfo} from "../../portfolio";

// Education.js
export default function Education() {
  if (educationInfo.display) {
    return (
      <div className="education-section content-rail" id="education">
        <h1
          className="skills-heading"

        >
          Education
        </h1>

        <div className="education-card-container">
          {educationInfo.schools.map((school, index) => (
            <EducationCard key={index} school={school} />
          ))}
        </div>
      </div>
    );
  }
  return null;
}
